import { jsxs as e, jsx as C } from "react/jsx-runtime";
function l(r) {
  return /* @__PURE__ */ e("svg", { fill: "none", height: "1em", viewBox: "0 0 24 24", width: "1em", ...r, children: [
    /* @__PURE__ */ C(
      "path",
      {
        d: "M12 2C6.4863 2 2 6.4858 2 12C2 17.5142 6.4863 22 12 22C17.5137 22 22 17.5142 22 12C22 6.4858 17.5137 2 12 2ZM12 20C7.5889 20 4 16.4111 4 12C4 7.5889 7.5889 4 12 4C16.4111 4 20 7.5889 20 12C20 16.4111 16.4111 20 12 20Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M15.9697 8.4697L10.5 13.9394L8.0303 11.4697C7.7373 11.1767 7.2627 11.1767 6.9698 11.4697C6.6769 11.7627 6.6768 12.2373 6.9698 12.5302L9.9698 15.5302C10.1163 15.6767 10.3077 15.7499 10.5001 15.7499C10.6925 15.7499 10.8839 15.6767 11.0304 15.5302L17.0304 9.5302C17.3234 9.2372 17.3234 8.7626 17.0304 8.4697C16.7374 8.1768 16.2626 8.1767 15.9697 8.4697Z",
        fill: "currentColor"
      }
    )
  ] });
}
export {
  l as default
};
